var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHeadsetMic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9F9F9F",
    d: "M10 .833a7.5 7.5 0 00-7.5 7.5v5.834c0 1.383 1.117 2.5 2.5 2.5h2.5V10H4.167V8.333C4.167 5.108 6.775 2.5 10 2.5s5.833 2.608 5.833 5.833V10H12.5v6.667h3.333v.833H10v1.667h5c1.383 0 2.5-1.117 2.5-2.5V8.333a7.5 7.5 0 00-7.5-7.5z"
  })));
}
export default __webpack_public_path__ + "c8b6ffae07c60ef561d522fbc690d815.svg";
export { SvgIconHeadsetMic as ReactComponent };